import type { ReactNode } from 'react';

import { SectionContainer } from './styles';

export interface SectionProps {
  children: ReactNode;
  full?: boolean;
  color?: string;
  spacing?: string;
  isHero?: boolean;
  className?: string;
  id?: string;
  ['data-cy']?: string;
}

export const Section = ({
  className,
  children,
  full = false,
  color,
  spacing,
  isHero,
  id,
  'data-cy': dataCy,
}: SectionProps) => {
  return (
    <SectionContainer
      className={className}
      full={full}
      color={color}
      spacing={spacing}
      isHero={isHero}
      data-cy={dataCy}
      id={id}
    >
      {children}
    </SectionContainer>
  );
};
